import { cva } from '@/styled-system/css';

export const propertyCardBodyRecipe = cva({
  base: {
    backgroundColor: {
      base: 'PropertyCard.Body.bg.default',
    },
    borderRadius: 'obj.default',
    display: 'grid',
    blockSize: 'auto',
    position: 'relative',
    transition: {
      _motionReduce: 'none',
      _motionSafe: '{box-shadow 0.2s ease-in, background-color 0.2s ease-in}',
    },

    boxShadow: {
      _focusVisible: 'focus',
    },
  },
  variants: {
    appearance: {
      large: {
        gridTemplateAreas: '"photo" "data" "flex"',
        gridTemplateRows: `{sizes.PropertyCard.PhotoWrapper.large.minHeight} minmax({0}, 1fr) auto`,
        blockSize: '100%',
      },
      small: {
        gridTemplateAreas: '"photo" "data"',
        gridTemplateRows: `{123px} minmax({112px}, 1fr)`,
      },
      horizontal: {
        gridTemplateAreas: '"photo data"',
        gridTemplateColumns: `{116px} minmax({0}, 1fr)`,
      },
    },
    elevated: {
      true: {},
      false: {},
    },
    interactive: {
      true: {
        'cursor': 'pointer',

        // Prevent clicks on child elements from triggering active state on body
        '&:not(:has(a:active, button:active, input:active, [role="button"]:active))': {
          boxShadow: {
            _active: 'focus',
          },
        },
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      elevated: true,
      interactive: false,
      css: {
        boxShadow: 'PropertyCard.Body.default',
      },
    },
    {
      elevated: true,
      interactive: true,
      css: {
        backgroundColor: {
          base: 'PropertyCard.Body.bg.default',
          _hover: 'PropertyCard.Body.bg.hover',
          _active: 'PropertyCard.Body.bg.pressed',
        },
        boxShadow: {
          base: 'PropertyCard.Body.default',
          _hover: 'PropertyCard.Body.hover',
        },
      },
    },
  ],
});
